namespace appn.views.taskTemplates.wizard3 {
    let _newFieldCounter = 0;

    export function init(): void {
        addEvents();

        initializeValues();
    }

    function addEvents() {
        $('form#appnForm').on('submit', function() {
            $('input[name=fileName]').each((index: number, fileName: HTMLElement) => {
                const filesInput = elementBuilder.getSimpleInputFor(undefined, `Wizard.Template.Task.Files[${index}].Name`, `Wizard_Template_Task_Files_${index}__Name`, elementBuilder.HTMLInputType.Hidden, undefined, $(fileName).val() as string);
                $('form#appnForm').append(filesInput);
            });

            return true;
        });

        $('#attachfiles').on('click', function(e) {
            e.preventDefault();
            const idx = new Date().getTime();

            $('#attachmentItems tbody').append(`<tr><td class="typeCell"><div><input type="hidden" name="Wizard.Template.Task.Files.Index" value="${idx}" /><input type="file" name="fileAttachments" id="fileAttachments${idx}" /><span class="field-validation-valid" data-valmsg-for="Wizard.Template.Task.Files[${idx}].Name" data-valmsg-replace="true"></span></div></td><td></td><td></td><td class="text-right">${elementBuilder.buildBtnRemoveRow('delete_file_button')}</td></tr>`);
        });

        $(document).on('click', '.delete_file_button', function() {
            $(this).parents('tr').remove();
        });

        // Preset Table Handlers
        $(document).on('click', '.delete_row', function() {
            const table = $(this).closest('table');
            $(this).closest('tr').remove();

            fixRowNumbers(table);
            appn.ui.handleParentResize(0, 0);
        });

        $('.addRow').on('click', function(this: HTMLElement, e: Event) {
            e.preventDefault();

            const id = $(this).attr('id') as string;
            const table = $(this).parent().find('table');

            drawRowEditor(table.data('tabledataname'), id);
            fixRowNumbers(table);

            select.init({
                selector: `table[id="${id}"] tbody tr select`
            });
        });
    }

    function initializeValues() {
        const tableColumnsInputs = $('input[id$="Value"]').filter('[parentname]');
        const columnValuesList: Array<ColumnValues> = [];

        tableColumnsInputs.each((index: number, input: HTMLElement) => {
            const savedValue: Array<string> = [];
            const isMulti = $(`input[dataname="${$(input).attr('dataname')}"][id$="Values"]`).length > 0 ? true : false;
            if (isMulti) {
                const columnValuesFlat = ($(input).attr('value') as string).split('|');
                for (let row = 0; row < columnValuesFlat[0].split('%%').length; row++) {
                    const rowValues: Array<string> = [];
                    columnValuesFlat.forEach((columnValue: string, index: number, self) => {
                        rowValues.push(columnValue.split('%%')[row]);
                    });
                    savedValue.push(rowValues.join('|'));
                }
            } else
                ($(input).attr('value') as string).split('%%').forEach((value: string) => {
                    savedValue.push(value);
                });

            const columnValues: ColumnValues = {
                tableName: $(input).attr('parentname') as string,
                columnName: $(input).attr('dataname') as string,
                multi: isMulti,
                values: savedValue
            };

            columnValuesList.push(columnValues);
        });

        columnValuesList.sort((a: ColumnValues, b: ColumnValues) => {
            if (a['tableName'] === b['tableName'])
                return 0;

            return (a['tableName'] < b['tableName']) ? -1 : 1;
        });
        const tableNames = columnValuesList.map(item => item.tableName).filter((value: string, index: number, self) => {
            return self.indexOf(value) === index;
        });

        tableNames.forEach((tableName: string, index: number, self) => {
            const columns = columnValuesList.filter((columnValue: ColumnValues, index: number, self) => {
                return columnValue.tableName === tableName;
            });

            // Find the biggest row count
            const valueCountMax = columns.map(item => item.values.filter((value: string, index: number, self) => {
                return value !== emptyString;
            }).length).reduce((a, b) => {
                return Math.max(a, b);
            });

            // return out if this table has no rows
            if (valueCountMax === 0)
                return;

            const rows = columns[0].values.length;

            for (let row = 0; row < rows; row++) {
                $(`.addRow[id="${$(`table[data-tabledataname="${tableName}"]`).attr('id')}"]`).click();
                columns.forEach((columnValue: ColumnValues, index: number, self) => {
                    const value = columnValue.multi ? columnValue.values[row].split('|') : columnValue.values[row];

                    $(`table[data-tabledataname="${tableName}"] .form-control#${columnValue.tableName}__${columnValue.columnName}__row-${row + 1}`).val(value);
                });
            }
        });
    }

    function drawRowEditor(tableName: string, tableId: string) {
        // Add a new row directly to the table
        const table = $(`table[id="${tableId}"]`);
        const body = table.find('tbody');
        const rows = body.find('tr').length;
        const tableHeaders = table.find('thead tr th');
        const initializePicker: Array<string> = [];
        const columnDataNames: Array<string> = [];

        tableHeaders.each((index: number, column: HTMLElement) => {
            const elementDataName = $(column).data('elementname');
            if (elementDataName) {
                columnDataNames.push(elementDataName);
                const elementType = $(column).data('elementtype');

                if (['Date', 'Time', 'DateTime'].indexOf(elementType) > -1)
                    initializePicker.push(elementType);
            }
        });

        const row = getRow(rows + 1, tableName, columnDataNames);

        body.append(row);

        $('.datepicker').on('click', function() {
            appn.ui.datePicker($(this));
        });

        $('.datetimepicker').on('click', function() {
            appn.ui.dateTimePicker($(this));
        });

        $('.timepicker').on('click', function() {
            appn.ui.timePicker($(this));
        });

        // Init new elements
        if (initializePicker.indexOf('Date') > -1)
            appn.ui.datePicker($('.datepicker'));
        if (initializePicker.indexOf('Time') > -1)
            appn.ui.timePicker($('.timepicker'));
        if (initializePicker.indexOf('DateTime') > -1)
            appn.ui.dateTimePicker($('.datetimepicker'));
    }

    function fixRowNumbers(table: JQuery<HTMLElement>): void {
        const rows = $(table.find('tbody tr'));
        rows.find('.delete_row').removeAttr('disabled');
        rows.each((index: number, row: HTMLElement) => {
            $(row).attr('id', index + 1);
            $(row).find('td').first().text(index + 1);

            if (rows.length <= 1)
                $(row).find('.delete_row').attr('disabled', 'disabled');
        });
    }

    function getRow(rowNumber: number, tableDataName: string, columnDataNames: Array<string>): HTMLElement {
        const rowNumberCell = elementBuilder.createElement('td', undefined, undefined, undefined, rowNumber.toString());
        const deleteAction = elementBuilder.buildBtnRemoveRow('delete_row');

        const deleteCell = elementBuilder.createElement('td');
        deleteCell.appendChild(deleteAction.toHtmlElement());

        const row = elementBuilder.createElement('tr', undefined, rowNumber.toString());
        row.appendChild(rowNumberCell);

        columnDataNames.forEach((columnDataName: string) => {
            row.appendChild(getCell(tableDataName, columnDataName));
        });

        row.appendChild(deleteCell);

        return row;
    }

    function getCell(tableDataName: string, columnDataName: string): HTMLElement {
        const column = $(`th[data-elementname="${columnDataName}"]`);
        const required = column.data('required') ? (column.data('required') as string).toBooleanExact() : false;

        // Set up for injectors
        const tableName = $(`input[type="hidden"][value="${tableDataName}"]`).attr('name') as string;
        const indexName = tableName.substring(0, tableName.lastIndexOf('['));
        const newFieldNumber = _newFieldCounter;
        const isMulti: boolean = column.data('elementtype') === 'SelectMulti' ? true : false;
        const repeatFieldIndex = `${indexName}[new-${newFieldNumber}]`;
        const inputName = `${repeatFieldIndex}.${isMulti ? 'Values' : 'Value'}`;
        const inputId = getIdString(inputName);
        const type = elementBuilder.HTMLElementType[column.data('elementtype') as keyof typeof elementBuilder.HTMLElementType];

        const formInput = elementBuilder.createElement('div', 'col-sm-12');
        const cell = elementBuilder.createElement('td');

        cell.appendChild(elementBuilder.getHiddenIndexerFor(indexName, newFieldNumber));
        _newFieldCounter++; // Allows the arbitrary naming of fields index to allow saving broken index lists (deleting and adding rows)

        cell.appendChild(elementBuilder.getSimpleInputFor(undefined, `${repeatFieldIndex}.DataName`, getIdString(`${repeatFieldIndex}.DataName`), elementBuilder.HTMLInputType.Hidden, undefined, columnDataName));
        cell.appendChild(elementBuilder.getSimpleInputFor(undefined, `${repeatFieldIndex}.Required`, getIdString(`${repeatFieldIndex}.Required`), elementBuilder.HTMLInputType.Hidden, undefined, required ? 'True' : 'False'));

        switch (type) {
            case elementBuilder.HTMLElementType.Date:
            case elementBuilder.HTMLElementType.DateTime:
            case elementBuilder.HTMLElementType.Time: {
                formInput.appendChild(elementBuilder.getDateTimePickerFor(type, 'form-control form-control-sm', inputName, inputId, undefined, undefined, required));

                break;
            }
            case elementBuilder.HTMLElementType.SelectOne:
            case elementBuilder.HTMLElementType.SelectMulti: {
                const values: Array<string> = JSON.parse((column.find('input[id$="_dataValues"]').attr('value') as string)) ?? [];
                const display: Array<string> = JSON.parse((column.find('input[id$="_dataDisplay"]').attr('value') as string)) ?? [];

                formInput.appendChild(elementBuilder.getSelectListFor(type, values, display, ['formatType', 'form-control form-control-sm'], inputName, inputId, undefined, required));

                break;
            }
            case elementBuilder.HTMLElementType.Decimal:
            case elementBuilder.HTMLElementType.Integer: 
            case elementBuilder.HTMLElementType.Long:
            case elementBuilder.HTMLElementType.Boolean:
            case elementBuilder.HTMLElementType.Hidden:
            case elementBuilder.HTMLElementType.Rest:
            case elementBuilder.HTMLElementType.Text: {
                const numLines = column.data('numlines') as number;

                if (numLines)
                    formInput.appendChild(elementBuilder.createElement('textarea', 'form-control form-control-sm', inputId, [['name', inputName], ['placeholder', T('Enter text...')], ['rows', '1'], ['cols', '20'], ['required', required ? 'required': '']]));
                else {
                    let placeholderType: string = emptyString;
                    let inputType: elementBuilder.HTMLInputType = elementBuilder.HTMLInputType.Text;

                    switch (type) {
                        case elementBuilder.HTMLElementType.Decimal: {
                            placeholderType = T('number (with decimals)');
                            break;
                        }
                        case elementBuilder.HTMLElementType.Integer:
                        case elementBuilder.HTMLElementType.Long: {
                            placeholderType = T('number (no decimals)');
                            break;
                        }
                        case elementBuilder.HTMLElementType.Boolean: { // Possibly deprecated
                            inputType = elementBuilder.HTMLInputType.CheckBox;
                            break;
                        }
                        default: {
                            placeholderType = T('text');
                            break;
                        }
                    }

                    formInput.appendChild(elementBuilder.getSimpleInputFor('form-control form-control-sm', inputName, inputId, inputType, placeholderType.length > 0 ? T('Enter {0}...', placeholderType) : undefined, undefined, required));
                }

                break;
            }
        }

        formInput.appendChild(elementBuilder.createElement('span', ['field-validation-valid', 'help-block', 'small'], undefined, [['data-valmsg-for', inputName], ['data-valmsg-replace', 'true']]));

        const formGroup = elementBuilder.createElement('div', ['form-group', 'row']);
        formGroup.appendChild(formInput);

        cell.appendChild(formGroup);

        return cell;
    }

    function getIdString(name: string): string {
        return name.split('[').join('_').split(']').join('_').split('.').join('_');
    }

    interface ColumnValues {
        [key: string]: string | Array<string> | boolean;
        tableName: string;
        columnName: string;
        multi: boolean;
        values: Array<string>;
    }
}
